<template>
    <el-dialog :title="titleLabel[dialogStatus] + '收款'" :visible.sync="dialogVisible" width="90%" top="40px">
      <table width=100%>
        <tr>
          <th width=25%>收入总额</th>
          <th width=25% >未到账金额</th>
          <th width=25% >已到账金额</th>
          <th width=25% >已抵扣金额</th>

          <th></th>
        </tr>
        <tr>
          <td>{{receivable_amount}}</td>
          <td>{{modify_unreceived_amount}}</td>
          <td>{{modify_received_amount}}</td>
          <td>{{deduction_amount}}</td>
          <td></td>
        </tr>
      </table>
      <el-divider></el-divider>
  
      <el-form :rules="rules" ref="dataForm" :model="formData" label-position="left" label-width="120px" class="mx-30">
        <el-form-item prop="insurance_company" label="收款账户">
          <el-select v-model="formData.received_account" placeholder="请选择收款账户">
            <el-option
              v-for="item in accountOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="account" label="到账金额">
          <el-input v-model="formData.account" autoComplete="on" disabled></el-input>
        </el-form-item>
        <el-form-item prop="pay_type" label="支付方式" >
        <el-select placeholder="请选择支付方式" v-model="formData.pay_type">
              <el-option v-for="s in pay_type_list" :key="s.id"
                        :label="s.label" :value="s.label"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item prop="transfer_type" label="转账方式">
        <el-select placeholder="请选择转账方式" v-model="formData.transfer_type">
              <el-option v-for="s in transfer_type_list" :key="s.id"
                        :label="s.label" :value="s.label"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item prop="received_date" label="到账日期">
          <el-date-picker
            v-model="formData.received_date"
            type="date"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="到账详细">
          <el-table show-summary size="mini" :key="0" :data="formData.finance_detail_apply_list" stripe fit height="250">
            <el-table-column align="left" label="可开发票">
              <template slot-scope="scope">
                <el-switch
                  v-model="scope.row.can_invoicing"
                  active-color="#13ce66"
                  inactive-color="#ff4949">
                </el-switch>
              </template>
            </el-table-column>
            <el-table-column align="left" label="船名">
              <template slot-scope="scope">
                <span>{{scope.row.ship_name}}</span>
              </template>
            </el-table-column>
            <el-table-column align="left" label="总保费">
                <template slot-scope="scope">
                <span>{{scope.row.total_insurance_premium}}</span>
                </template>
            </el-table-column>
            <el-table-column align="left" label="抵扣保费">
                <template slot-scope="scope">
                  <span>{{scope.row.deduction_insurance_premium}}</span>
                </template>
            </el-table-column>
            <el-table-column align="left" label="已到保费" v-if="false">
                <template slot-scope="scope">
                  <span>{{conputed_received_amount(scope.row.received_insurance_premium, scope.row.insurance_premium, scope.row.init_insurance_premium)}}</span>
                </template>
            </el-table-column>

            <el-table-column align="left" label="未到保费">
                <template slot-scope="scope">
                  <span>{{conputed_unreceived_amount(scope.row.total_insurance_premium, scope.row.received_insurance_premium, scope.row.deduction_insurance_premium, scope.row.insurance_premium, scope.row.init_insurance_premium)}}</span>
                </template>
            </el-table-column>

            <el-table-column align="left" prop="insurance_premium">
                <template slot="header">
                  到账保费
                  <el-tooltip class="item" placement="left" content="将到账保费加上未到保费" >
                    <el-button type="text" size="mini" @click="addition_insurance_premium_amount()">
                      <i class="el-icon-document-copy"></i>
                    </el-button>
                  </el-tooltip>
                </template>
                <template slot-scope="scope">
                  <el-input type="number" v-model="scope.row.insurance_premium"/>
                </template>
            </el-table-column>
            
            <el-table-column align="left" label="总风险金">
                <template slot-scope="scope">
                <span>{{scope.row.total_risk_premium}}</span>
                </template>
            </el-table-column>
            <el-table-column align="left" label="抵扣风险金">
                <template slot-scope="scope">
                <span>{{scope.row.deduction_risk_premium}}</span>
                </template>
            </el-table-column>
            <el-table-column align="left" label="已到风险金" v-if="false">
                <template slot-scope="scope">
                <span>{{conputed_received_amount(scope.row.received_risk_premium, scope.row.risk_premium, scope.row.init_risk_premium)}}</span>
                </template>
            </el-table-column>

            <el-table-column align="left" label="未到风险金">
                <template slot-scope="scope">
                  {{ conputed_unreceived_amount(scope.row.total_risk_premium, scope.row.received_risk_premium, scope.row.deduction_risk_premium, scope.row.risk_premium, scope.row.init_risk_premium) }}
                </template>
            </el-table-column>
            <el-table-column align="left" prop="risk_premium">
              <template slot="header">
                到账风险金
                <el-tooltip class="item" placement="left" content="将到账风险金加上未到风险金" >
                  <el-button type="text" size="mini" @click="addition_risk_premium_amount()">
                    <i class="el-icon-document-copy"></i>
                  </el-button>
                </el-tooltip>
              </template>
                <template slot-scope="scope">
                    <el-input type="number" v-model="scope.row.risk_premium"/>
                </template>
            </el-table-column>

            </el-table>
        </el-form-item>
        <el-form-item prop="source_document" label="原始凭证">
          <el-upload
            :data="formData"
            ref="upload"
            :headers="headers"
            action=""
            :file-list="source_document_list"
            list-type="picture"
            :on-remove="handleRemoveSourceDocument"
            :on-preview="handlePreviewSourceDocument"
            :http-request="handleSubmitWithSourceDocument"
            :auto-upload="false"
          >
            <template v-if="showDialogSave">
            <el-button slot="trigger" size="small" type="success">选择凭证</el-button>
            </template>
          </el-upload>
        </el-form-item>
        <el-form-item prop="remark" label="备注">
          <el-input v-model="formData.remark" autocomplete="on" type="textarea" :autosize="{minrows: 4, maxrows: 6}"></el-input>
        </el-form-item>
  
        <el-form-item>
          <span style="float: right">
            <template v-if="showDialogSave">
            <el-button size="small" @click="cancelData">取消</el-button>
            <el-button v-if="dialogStatus=='action.create'"
                       type="primary" size="small"
                       @click="saveData">保存</el-button>
            <el-button
                v-if="dialogStatus == 'action.edit' && (is_superuser ||(!is_superuser && !formData.is_superuser))"
                type="primary" size="small"
                @click="saveData">保存</el-button>
            </template>
          </span>
        </el-form-item>
      </el-form>
    </el-dialog>
  </template>
  
  <script>
    import { fetchInsuranceFinanceDetail, createInsuranceFinanceDetail, updateInsuranceFinanceDetail } from '@/api/group-insurance'
    import { fetchSourceDocumentList, deleteSourceDocument} from '@/api/group-insurance'
    import { fetchSettingCollectAccountOptions } from '@/api/billing'
    import { getToken } from '@/utils/auth'
    import { EventBus } from "@/utils/event-bus"
    import { formatDateTime } from "@/utils/misc"
  
    export default {
      name: 'finance-detail-dialog',
      props: [
        'finance_id',
        'receivable_amount',
        'received_amount',
        'unreceived_amount',
        'deduction_amount',
      ],
      data() {
        var validateAmount = (rule, value, callback) => {
          if(this.modify_unreceived_amount < 0.0) {
            // return callback(new Error('未到账金额小于0'))
            return callback()
          } else {
            return callback()
          }
        };
        return {
          finance_detail_id: null,
          is_superuser: undefined,
          dialogStatus: null,
          dialogVisible: false,
          showDialogSave: true,
          titleLabel: {
            'action.create': '新增',
            'action.edit': '编辑'
          },
          accountOptions:[],
          pay_type_list: [
          {value: '0', label: '线上支付',id: 1}, 
          {value: '1', label: '线下支付',id: 2}, 
            ],
          transfer_type_list: [
              {value: '0', label: '公对公',id: 1}, 
              {value: '1', label: '私对公',id: 2}, 
            ],
          formData: {
            received_account: '',
            account: 0,
            received_date: null,
            finance: null,
            pay_type:null,
            transfer_type:null,
            finance_detail_apply_list: [],
          },
          rules: {
            account: [
              {required: true, message:'请输入到账金额' ,trigger: 'blur'},
              {validator: validateAmount, trigger: 'blur'}
            ],
            received_date: [{required: true, message:'请选择到账日期' ,trigger: 'blur'}],
          },
          init_amount: 0.0,
          source_document_list:[]
        }
      },
      computed: {
        modify_received_amount: function(){
          if (this.formData.account === null || this.formData.account === undefined || this.formData.account === '') {return this.received_amount}
          let result = this.received_amount + parseFloat(this.formData.account) - this.init_amount
          return result.toFixed(2)
        },
        modify_unreceived_amount: function(){
          let result = this.receivable_amount - this.modify_received_amount - this.deduction_amount
          return result.toFixed(2)
        },
        headers() {
          return {'Authorization': 'Token ' + getToken()}
        }
      },
      watch: {
        'formData.finance_detail_apply_list': {
          handler(newVal, oldVal) {
            let result = 0
            newVal.forEach(item => {
              if (item.insurance_premium !== '' && item.insurance_premium !== null && item.insurance_premium !== undefined) {
                result += parseFloat(item.insurance_premium)
              } else {
                this.$set(item, 'insurance_premium', 0)
              }
              if (item.risk_premium !== '' && item.risk_premium !== null && item.risk_premium !== undefined) {
                result += parseFloat(item.risk_premium)
              } else {
                this.$set(item, 'risk_premium', 0)
              }
            })
            this.formData.account = result.toFixed(2)
          },
          deep: true
        },
      },
      methods: {
        resetFormData() {
          this.formData = {
            received_account: '',
            account: 0,
            received_date: null,
            finance: null,
            remark: null,
            pay_type:null,
            transfer_type:null,
            finance_detail_apply_list: [],
          }
          this.init_amount = 0.0
        },
        conputed_received_amount(received_amount, receiving_amount, init_amount) {
          if (receiving_amount === '' || receiving_amount === null || receiving_amount === undefined) {
            return receiving_amount.toFixed(2)
          }
          let result = received_amount + parseFloat(receiving_amount) - init_amount
          return result.toFixed(2)
        },
        conputed_unreceived_amount(total_amount, received_amount, deduction_amount, receiving_amount, init_amount) {
          let result = total_amount - deduction_amount - received_amount + init_amount
          if (receiving_amount !== '' && receiving_amount !== null && receiving_amount !== undefined) {
            result = result - receiving_amount
          }
          return result.toFixed(2)
        },
        addition_insurance_premium_amount() {
          this.formData.finance_detail_apply_list.forEach(item => {
            let addition_amount = parseFloat(item.insurance_premium) + parseFloat(this.conputed_unreceived_amount(item.total_insurance_premium, item.received_insurance_premium, item.deduction_insurance_premium, item.insurance_premium, item.init_insurance_premium))
            this.$set(item, 'insurance_premium', parseFloat(addition_amount))
          })
        },
        addition_risk_premium_amount() {
          this.formData.finance_detail_apply_list.forEach(item => {
            let addition_amount = parseFloat(item.risk_premium) + parseFloat(this.conputed_unreceived_amount(item.total_risk_premium, item.received_risk_premium, item.deduction_risk_premium, item.risk_premium, item.init_risk_premium))
            this.$set(item, 'risk_premium', parseFloat(addition_amount))
          })
        },
        handleGetSourceDocumentList(receivedId) {
          fetchSourceDocumentList(receivedId, 'insurancefinancedetail')
            .then( resp=>{
              console.log(resp)
              this.source_document_list = resp
            }).catch( err=>{
              this.$error_message(err)
            })
        },
        handlePreviewSourceDocument(file) {
          window.open(file.url, "_blank")
        },
        handleRemoveSourceDocument(file, fileList) {
          console.log(file.name, file.id)
          for (let f of fileList) {
            console.log(f.name, f.id)
          }
          if (this.showDialogSave) {
            deleteSourceDocument(file.id)
              .then( resp=>{
                this.$message.success('凭证已被删除')
              }).catch( err=>{
                this.$error_message(err)
              })
          }
        },
        handleCreate(selected_apply_list) {
          
          this.dialogStatus = 'action.create'
          this.is_superuser = this.$store.getters.is_superuser
          
          this.resetFormData()
          let tmp_selected_apply_list = JSON.parse(JSON.stringify(selected_apply_list))
          tmp_selected_apply_list.forEach(item => {
            this.$set(item, 'total_insurance_premium', parseFloat((item.small_premium + item.big_premium).toFixed(2)))
            this.$set(item, 'total_risk_premium', parseFloat(item.risk_premium.toFixed(2)))
            let received_insurance_premium = 0, received_risk_premium = 0
            item.apply_finance_detail_list.forEach(apply_finance_detail => {
              received_insurance_premium += apply_finance_detail.insurance_premium
              received_risk_premium += apply_finance_detail.risk_premium
            })
            this.$set(item, 'received_insurance_premium', parseFloat(received_insurance_premium.toFixed(2)))
            this.$set(item, 'insurance_premium', 0)
            this.$set(item, 'init_insurance_premium', 0)
            this.$set(item, 'received_risk_premium', parseFloat(received_risk_premium.toFixed(2)))
            this.$set(item, 'risk_premium', 0)
            this.$set(item, 'init_risk_premium', 0)
          })
          this.$set(this.formData, 'finance_detail_apply_list', tmp_selected_apply_list)
          this.source_document_list = []
          this.dialogVisible = true
        },
        handleUpdate(id, showDialogSave, apply_list) {
          this.showDialogSave = showDialogSave
          this.dialogStatus = 'action.edit'
          let login_userid = this.$store.state.user.user
          this.finance_detail_id = id
          fetchInsuranceFinanceDetail(this.finance_detail_id)
            .then(res => {
              this.formData = Object.assign({}, res)
              this.formData.finance_detail_apply_list.forEach(item => {
                let apply = JSON.parse(JSON.stringify(
                  apply_list.find(apply => {return (apply.id === item.apply)})
                ))
                this.$set(item, 'ship_name', apply.ship_name)
                this.$set(item, 'can_invoicing', apply.can_invoicing)
                this.$set(item, 'deduction_insurance_premium', apply.deduction_insurance_premium)
                this.$set(item, 'deduction_risk_premium', apply.deduction_risk_premium)
                this.$set(item, 'init_insurance_premium', item.insurance_premium)
                this.$set(item, 'init_risk_premium', item.risk_premium)
                this.$set(item, 'total_insurance_premium', parseFloat((apply.small_premium + apply.big_premium).toFixed(2)))
                this.$set(item, 'total_risk_premium', parseFloat((apply.risk_premium).toFixed(2)))
                let received_insurance_premium = 0, received_risk_premium = 0
                apply.apply_finance_detail_list.forEach(apply_finance_detail => {
                  received_insurance_premium += apply_finance_detail.insurance_premium
                  received_risk_premium += apply_finance_detail.risk_premium
                })
                this.$set(item, 'received_insurance_premium', parseFloat(received_insurance_premium.toFixed(2)))
                this.$set(item, 'received_risk_premium', parseFloat(received_risk_premium.toFixed(2)))
              })
              // this.is_owner = (login_userid == id)
              this.dialogVisible = true
              this.init_amount = this.formData.account
              this.handleGetSourceDocumentList(this.finance_detail_id)
            })
            .catch(error => {
              this.$error_message(error)
            })
        },
        cancelData() {
          this.resetFormData()
          this.$nextTick(() => {
            this.$refs.dataForm.clearValidate()
          })
          this.dialogVisible = false
        },
  
        needSubmitWithSourceDocument() {
          // 检查是否有需要上传的文件存在,判断标准为组件upload的上传文件属性中是否存在raw字段
          let needUpload = false
          if (this.$refs.upload.uploadFiles.length > 0){
            for (let f of this.$refs.upload.uploadFiles){
              if ('raw' in f) {
                needUpload = true
                break
              }
            }
            return needUpload
          }
        },
        handleSubmitWithSourceDocument(param){
          let fd = new FormData()
          // Object.keys(this.formData).forEach((k)=>{
          //   fd.set(k, this.formData[k])
          // })
          console.log(this.formData)
          this.formData.finance = this.finance_id
          let oldDate = new Date(this.formData.received_date).getTime()
          let newDate = new Date(oldDate)

          fd.set('pay_type', this.formData.pay_type)
          fd.set('transfer_type', this.formData.transfer_type)

          fd.set('received_account', this.formData.received_account)
          fd.set('finance_detail_apply_list', JSON.stringify(this.formData.finance_detail_apply_list))
          fd.set('account', this.formData.account)
          fd.set('received_date', formatDateTime(newDate))
          fd.set('finance', parseInt(this.formData.finance))
          fd.set('remark', this.formData.remark)
          console.log(fd)

          
  
          if (param !== null){
            let fileObj = param.file
            fd.append('file', fileObj)
          }
  
          if (this.dialogStatus === 'action.create'){
            createInsuranceFinanceDetail(fd)
              .then(res => {
                this.$message.success(`新增收款成功, id=${res.id}`)
                this.$nextTick(() => {
                  this.resetFormData()
                  this.$refs['dataForm'].clearValidate()
                  this.dialogVisible = false
                  this.$emit('updateList')
                })
              })
              .catch(error => {
                this.$error_message(error)
              })
          } else if (this.dialogStatus === 'action.edit'){
            updateInsuranceFinanceDetail(this.finance_detail_id, fd)
              .then(() => {
                this.$message.success('修改收款信息成功')
                this.$refs.dataForm.resetFields()
                this.dialogVisible = false
                this.$emit('updateList')
              })
              .catch(error => {
                this.$error_message(error)
              })
  
          } else {
            this.$error_message('无效的操作')
          }
        },
        saveData(){
          this.$refs['dataForm'].validate(valid => {
            if (valid) {
              if (this.needSubmitWithSourceDocument()) {
                this.$refs.upload.submit()
              } else {
                this.handleSubmitWithSourceDocument(null)
              }
            }
          })
        }
      },
      created(){
        fetchSettingCollectAccountOptions({type:2}).then(res => {
          this.accountOptions = res
          this.formData.finance = this.finance_id
        }).catch(err => {
          this.$error_message(err)
        })
      }
    }
  </script>
  